import { requestREST } from "~/client/http/CommonHTTP";
import { NetworkResponse } from "~/app/type/common";
import {
  CoursesPostSchema,
  CoursesSchema,
  CoursesResponse,
  IParamsCourses,
} from "~/entity/Courses";
import {
  CourseLevel,
  CourseLevelGetterParams,
} from "~/entity/Courses/model/shema";

const coursesServiceMap = {
  getCourses: "/employee/courses",
  getExpectations: "/employee/expectations",
  getLevels: "/employee/levels",
};

export class CoursesService {
  static GET = {
    getCourses: (
      params: IParamsCourses
    ): NetworkResponse<{ courses: CoursesResponse[]; total: number }> =>
      requestREST.get("/employee/courses", { params }),

    getCoursesSingle: (
      id: string | number
    ): NetworkResponse<{ course: CoursesResponse }> =>
      requestREST.get(`${coursesServiceMap.getCourses}/${id}`),

    getExpectationsSingle: (
      id: string | number
    ): NetworkResponse<{ expectation: CoursesSchema }> =>
      requestREST.get(`${coursesServiceMap.getExpectations}/${id}`),

    getLevels: (
      params: CourseLevelGetterParams
    ): NetworkResponse<{ levels: CourseLevel[] }> =>
      requestREST.get(coursesServiceMap.getLevels, { params }),
  };

  static POST = {
    createCourses: (data: CoursesPostSchema): NetworkResponse<CoursesSchema> =>
      requestREST.post(coursesServiceMap.getCourses, data),
  };

  static PUT = {
    putCourses: (data: CoursesResponse): NetworkResponse<CoursesSchema> =>
      requestREST.put(coursesServiceMap.getCourses, data),
  };
}
